import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 18,
	viewBox: "0 0 15 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "icon",
		d: "M13.6364 2.76923H12.2727V1.38462C12.2727 0.623077 11.6591 0 10.9091 0H1.36364C0.613636 0 0 0.623077 0 1.38462V13.8462C0 14.6077 0.613636 15.2308 1.36364 15.2308H2.72727V16.6154C2.72727 17.3769 3.34091 18 4.09091 18H13.6364C14.3864 18 15 17.3769 15 16.6154V4.15385C15 3.39231 14.3864 2.76923 13.6364 2.76923ZM2.72727 4.15385V13.8462H1.36364V1.38462H10.9091V2.76923H4.09091C3.34091 2.76923 2.72727 3.39231 2.72727 4.15385ZM13.6364 16.6154H4.09091V4.15385H13.6364V16.6154Z",
		fill: "#C4C4C4"
	})
});
export default SvgIcon;
